import React from 'react';
import { styled } from 'styled-components';

import { DividerWrapper } from './styles';
import { DividerProps } from './types';

const Divider = ({ text, className }: DividerProps) => {
  return (
    <DividerWrapper className={className}>
      <hr />

      {text && (
        <>
          <span>{text}</span>
          <hr />
        </>
      )}
    </DividerWrapper>
  );
};
export default styled(Divider)``;
